import styled from 'styled-components';
import { Colors } from '../../../styles/colors';

export const ContainerReport = styled.div`
	display: flex;
	width: 60%;
	flex-direction: column;
`;
export const ContentUserInfo = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
	margin-top: 1rem;
`;
export const ContainerReportinfo = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	height: 65vh;
	padding-bottom: 80px;
	overflow-y: auto;
	::-webkit-scrollbar {
		width: 3px;
		height: 3px;
	}
	::-webkit-scrollbar-thumb {
		background: #e0e0e0;
		border-radius: 3px;
	}
	::-webkit-scrollbar-track {
		background: #ffffff;
		border-radius: 3px;
	}
`;
export const ContainerReportOptions = styled.div`
	display: flex;
	width: 100%;
	margin-top: 36px;
	flex-direction: row;
`;
export const ReportOptions = styled.div<{borderColor: string}>`
	display: flex;
	width: 50%;
	flex-direction: row;
	justify-content: center;
	border-bottom: 4px solid ;
	padding-bottom: 12px;
	border-bottom-color: ${({borderColor})=> borderColor};
	cursor: pointer;
`;
export const Press = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	cursor: pointer;
`;
export const ContainerIcon = styled.div``;
export const ContainerHandImages = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-around;
	flex-direction: row;
	margin-top: 36px;
`;
export const ContainerTextUpdateResult = styled.div`
	display: flex;
	cursor: pointer;
	align-items: center;
	margin-top: 36px;
`;
export const HandContainer = styled.div<{align: string}>`
	display: flex;
	width: 30%;
	justify-content: ${({align})=> align};
	position: relative;
`;
export const ContainerInfoImage = styled.div<{borderBottom?: boolean, visible?: boolean, top?: number, left?: number, right?: number}>`
	display: ${({visible})=> visible ? 'flex' : 'none'};
	border-bottom: ${({borderBottom})=> borderBottom ? `1.42px solid ${Colors.neutral_grey_k_50}`: '0px'};
	border-bottom-color: ${({borderBottom})=> borderBottom ? Colors.neutral_grey_k_50 : 'transparent'};
	position: absolute;
	padding-right: 10px;
	top: ${({top})=> top ? top : 0}px;
	left: ${({left})=> left ? `${left}px` : 'undefined'};
	right: ${({right})=> right ? `${right}px` : 'undefined'};
`;
export const ContainerTable = styled.div`
	width: 100%;
	height: 70vh;
	padding: 0px 12px;
	margin-top: 30px;
	padding-bottom: 80px;
	::-webkit-scrollbar {
		width: 3px;
		height: 3px;
	}
	::-webkit-scrollbar-thumb {
		background: #e0e0e0;
		border-radius: 3px;
	}
	::-webkit-scrollbar-track {
		background: #ffffff;
		border-radius: 3px;
	}
`;
export const ContentTable = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	border-radius: 10px;
	padding-bottom: 20px;
	border: 1.36px solid  ${Colors.neutral_grey_k_20};
	border-color: ${Colors.neutral_grey_k_20};
`;
export const ContainerSection = styled.div<{borderTopWidth?: boolean}>`
	width: 100%;
	border-top-width: ${({borderTopWidth})=>borderTopWidth ? 1 : 0}px;
	border-top-color: ${({borderTopWidth})=> borderTopWidth ? Colors.neutral_grey_k_20 : 'transparent'};
	border-top-left-radius: ${({borderTopWidth})=> !borderTopWidth ? 10 : 0}px;
	border-top-right-radius: ${({borderTopWidth})=> !borderTopWidth ? 10 : 0}px;
	padding: 16px;
`;
export const ContainerHeader = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	padding: 8px 5px;
`;
export const HeaderInfo = styled.div<{width: number}>`
	width: ${({width})=> width}%;
	display: flex;
	flex-direction: column;
`;
interface CellHeaderProps {
	width:number;
	borderTopWidth?:number;
	borderLeftWidth?:number;
	borderRightWidth?:number;
	borderColor?: string;
	borderTopLeftRadius?:number;
	borderTopRightRadius?:number;
	borderBottomWidth?:number;
	bgColor?:string;
	padding?: boolean
};
export const RowTable = styled.div<Partial<CellHeaderProps>>`
	width: 100%;
	display: flex;
	flex-direction: row;
	border-left-style: solid;
	border-right-style: solid;
	border-bottom-style: solid;
	background-color: ${({bgColor})=> bgColor ? bgColor : Colors.white};
	border-left-width: ${({borderLeftWidth})=> borderLeftWidth ? borderLeftWidth : 0 }px;
	border-right-width: ${({borderRightWidth})=> borderRightWidth ? borderRightWidth : 0 }px;
	border-bottom-width: ${({borderBottomWidth})=> borderBottomWidth ? borderBottomWidth : 0}px;
	border-bottom-color: ${({borderColor})=> borderColor ? borderColor : Colors.neutral_grey_k_5};
	border-color:${({borderColor})=> borderColor ? borderColor : 'transparent' };
	padding:${({padding})=> padding ? '5px 0px 5px 5px' : '0px'} ;
`;
export const Cell = styled.div<{width: number, bgColor?: string, paddingLeft?:number}>`
	width: ${({width})=> width}%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	padding-left: ${({paddingLeft})=> paddingLeft ? paddingLeft : 0}px;
	background-color: ${({bgColor})=> bgColor? bgColor : Colors.white};
`;
export const BgColorCell = styled.div<{width?:number, bgColor?: string}>`
	width: ${({width})=> width ? width : 0}%;
	height: 100%;
	background-color: ${({bgColor})=> bgColor? bgColor : 'transparent'};
	position: absolute;
	left: 0px;
`;

export const ContainerHeaderComponents = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	background-color: white;
`;


export const CellHeaderComponents = styled.div<CellHeaderProps>`
	width: ${({width})=> width}%;
	padding: 4px 8px;
	position: relative;
	background-color: ${({bgColor})=> bgColor ? bgColor : 'transparent'};
	border: ${({borderColor})=> borderColor ? `1px solid ${borderColor}` : 'transparent' };
	border-top-width: ${({borderTopWidth})=> borderTopWidth ? `${borderTopWidth}px solid` : '0px' };
	border-left-width: ${({borderLeftWidth})=> borderLeftWidth ? borderLeftWidth : 0 }px;
	border-right-width: ${({borderRightWidth})=> borderRightWidth ? borderRightWidth : 0 }px;
	border-bottom-width: ${({borderBottomWidth})=> borderBottomWidth ? borderBottomWidth : 0 }px;
	border-top-left-radius: ${({borderTopLeftRadius})=> borderTopLeftRadius ? borderTopLeftRadius : 0 }px;
	border-top-right-radius: ${({borderTopRightRadius})=> borderTopRightRadius ? borderTopRightRadius : 0 }px;
`;
export const ContainerLegend = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	padding: 20px 10px 0px 10px;
`;
export const ContentLegend = styled.div<{visible?: boolean}>`
	display: ${({visible})=> visible ? 'flex' : 'none'};
	width: 100%;
	flex-direction: column;
	margin-top: 24px;
`;
export const ContentOptionLegend = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
`;
export const OptionL = styled.div<{marginRight?:number}>`
	display: flex;
	margin-top: 6px;
	margin-right: ${({marginRight})=>marginRight ? marginRight : 7 }px;
`;
export const Square = styled.div<{bgColor: string}>`
	width: 14px;
	height: 14px;
	margin-right: 5px;
	border-radius: 2px;
	background-color: ${({bgColor})=>bgColor};
`;
export const TextLegend  = styled.p`
	font-family:'NotoSans-Regular';
	font-size: 12px;
	color: ${Colors.neutral_grey_k_70};
`;
export const ContainerReference = styled.div`
	display: flex;
	width: 100%;
	margin-top: 5px;
	flex-direction: row;
`;

export const ContainerGrafic = styled.div`
	width: 100%;
	margin-top:12px;
`;
export const TextCellAssimetryEvolution = styled.p<{fontWeight?:number, align?:string}>`
	font-size: 12px;
	display: flex;
	font-family:'NotoSans-Regular';
	color: ${Colors.neutral_grey_k_70};
	text-align: ${({align})=> align ? align : 'left'};
	font-weight: ${({fontWeight})=> fontWeight ? fontWeight : 400};
`;

